import React from 'react';

function Invoice(props: object) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 6.5625H4.6875C4.19022 6.5625 3.71331 6.76004 3.36167 7.11167C3.01004 7.46331 2.8125 7.94022 2.8125 8.4375C2.8125 8.93478 3.01004 9.41169 3.36167 9.76332C3.71331 10.115 4.19022 10.3125 4.6875 10.3125H6.5625C7.05978 10.3125 7.53669 10.51 7.88832 10.8617C8.23996 11.2133 8.4375 11.6902 8.4375 12.1875C8.4375 12.6848 8.23996 13.1617 7.88832 13.5133C7.53669 13.865 7.05978 14.0625 6.5625 14.0625H3.28125"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 5.625V6.5625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 14.0625V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 6.5625H26.25V22.5C26.25 22.7486 26.1512 22.9871 25.9754 23.1629C25.7996 23.3387 25.5611 23.4375 25.3125 23.4375H4.6875C4.43886 23.4375 4.2004 23.3387 4.02459 23.1629C3.84877 22.9871 3.75 22.7486 3.75 22.5V17.8125"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1875 12.1875H26.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 17.8125H26.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6875 12.1875V23.4375"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Invoice;
